import type { Theme } from '@vfuk/core-themes'

import type { SimpleBadgeTheme } from './SimpleBadge.theme.types'

const defaultTheme = (theme: Theme): SimpleBadgeTheme => {
  return {
    appearance: {
      primary: {
        color: theme.color.primary1.default,
      },
      secondary: {
        color: theme.color.secondary1.default,
      },
    },
  }
}

export default defaultTheme
